import React, { useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import classNames from "classnames";
import { xor } from "lodash";
import styles from "./MultiSelect.module.scss";
import { ReactComponent as DownArrowIcon } from "../../icons/down-arrow.svg";
import { ReactComponent as UpArrowIcon } from "../../icons/up-arrow.svg";

function MultiSelect({
  label,
  options,
  onChangeSelectedValues,
  selectedValues,
  disabled,
  className,
}) {
  const [multiSelectActive, setMultiSelectActive] = useState(false);

  const handleCloseMultiSelect = () => {
    setMultiSelectActive(false);
  };

  const handleClearFilters = () => {
    onChangeSelectedValues([]);
  };

  return (
    <div className={styles.wrapper}>
      <div
        className={classNames(
          styles.button,
          disabled && styles.disabled,
          selectedValues?.length > 0 && styles.active,
          className,
        )}
        onMouseDown={() =>
          !disabled && setMultiSelectActive(!multiSelectActive)
        }
        onKeyDown={() => !disabled && setMultiSelectActive(!multiSelectActive)}
      >
        <div className={styles.leftContainer}>
          {multiSelectActive ? (
            <UpArrowIcon className={styles.icon} />
          ) : (
            <DownArrowIcon className={styles.icon} />
          )}
          <span>{label}</span>
        </div>
        {selectedValues?.length > 0 && (
          <div
            className={styles.crossIconWrapper}
            onClick={handleClearFilters}
          />
        )}
      </div>
      <OutsideClickHandler
        onOutsideClick={handleCloseMultiSelect}
        disabled={!multiSelectActive}
      >
        {multiSelectActive && options && (
          <div className={styles.options}>
            {options.map((option) => (
              <div
                key={option.id}
                className={styles.option}
                onClick={() => {
                  onChangeSelectedValues(xor(selectedValues, [option.id]));
                }}
                onKeyDown={() =>
                  onChangeSelectedValues(xor(selectedValues, [option.id]))
                }
              >
                <div
                  className={classNames(styles.checkbox, {
                    [styles.active]: selectedValues.includes(option.id),
                  })}
                />
                <span
                  className={classNames(styles.optionLabel, {
                    [styles.selected]: selectedValues.includes(option.id),
                  })}
                >
                  {option.label}
                </span>
              </div>
            ))}
          </div>
        )}
      </OutsideClickHandler>
    </div>
  );
}

export default MultiSelect;
